var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToastMic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_915_264)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FFD2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0878 50.2856C26.0151 50.2478 25.9445 50.2088 25.8739 50.1741C25.6061 50.0582 25.3852 49.8578 25.2463 49.6045C25.1074 49.3512 25.0584 49.0596 25.1069 48.7759C25.1554 48.4785 25.3103 48.208 25.5437 48.0132C25.7772 47.8183 26.0737 47.7119 26.3798 47.7132C27.8314 47.7016 29.284 47.7132 30.7355 47.7132H31.1463V44.2865C30.5612 44.1655 29.9696 44.0708 29.3856 43.9172C26.786 43.2493 24.5008 41.7188 22.9163 39.5846C21.3738 37.5487 20.61 35.2404 20.5715 32.7016C20.5608 32.0704 20.8924 31.599 21.4572 31.4086C21.9921 31.2287 22.6028 31.3854 22.9066 31.8515C23.0701 32.1115 23.1639 32.4079 23.1794 32.7132C23.2585 34.7585 23.8661 36.6165 25.1636 38.2305C26.6836 40.1243 28.655 41.3132 31.0885 41.6288C34.8324 42.116 37.8574 40.8208 40.0908 37.8265C41.2333 36.2957 41.72 34.5312 41.7713 32.6406C41.7948 31.7989 42.4634 31.2423 43.2892 31.357C43.931 31.4464 44.3952 32.002 44.3845 32.7016C44.3449 35.253 43.5758 37.5729 42.0173 39.6119C40.1935 41.9992 37.7729 43.4921 34.796 44.1013C34.4676 44.1686 34.1349 44.2128 33.798 44.2696V47.708H34.1873C35.5908 47.708 36.9942 47.708 38.3976 47.708C39.1966 47.708 39.7154 48.092 39.8523 48.7748C39.9764 49.3945 39.6309 49.9321 38.9153 50.2341C38.896 50.2425 38.8832 50.2677 38.8682 50.2846L26.0878 50.2856Z",
    fill: "url(#paint0_linear_915_264)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8022 26.7708C39.8022 28.6509 39.8278 30.531 39.7957 32.4112C39.7444 35.4865 38.3346 37.7591 35.5074 39.11C31.8117 40.8775 27.0956 38.9785 25.6665 35.1888C25.3281 34.2955 25.1553 33.3497 25.1563 32.3964C25.1563 28.6242 25.1563 24.8521 25.1563 21.0799C25.1627 17.8183 27.0645 15.1722 30.1505 14.098C34.0292 12.7482 38.5153 15.0902 39.5155 19.0167C39.6867 19.7083 39.7785 20.4166 39.7893 21.1283C39.8268 23.0095 39.8022 24.8906 39.8022 26.7708Z",
    fill: "url(#paint1_linear_915_264)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_915_264",
    x1: 33.1427,
    y1: 31.0398,
    x2: 32.9642,
    y2: 50.2901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C92020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9595"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_915_264",
    x1: 32.8932,
    y1: 13.3066,
    x2: 32.3447,
    y2: 39.7735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C92020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9595"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_915_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastMic);
export default __webpack_public_path__ + "static/media/toast-mic.c9ee69edc34d182559603248b2bf4b67.svg";
export { ForwardRef as ReactComponent };